function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurrencyWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 135.467 135.467",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M39.828 10.602c-21.19 0-38.437 17.248-38.437 38.437 0 21.19 17.248 38.438 38.437 38.438 21.19 0 38.44-17.249 38.44-38.438 0-21.19-17.25-38.437-38.44-38.437zm0 6.699c17.568 0 31.738 14.17 31.738 31.738 0 17.568-14.17 31.738-31.738 31.738-17.568 0-31.738-14.17-31.738-31.738 0-17.568 14.17-31.738 31.738-31.738z",
    style: {
      color: "rgb(0,0,0)",
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: "normal",
      fontFamily: "sans-serif",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontVariantEastAsian: "normal",
      fontFeatureSettings: "normal",
      fontVariationSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecoration: "none",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "rgb(0,0,0)",
      letterSpacing: "normal",
      wordSpacing: "normal",
      textTransform: "none",
      writingMode: "lr-tb",
      direction: "ltr",
      textOrientation: "mixed",
      dominantBaseline: "auto",
      baselineShift: "baseline",
      textAnchor: "start",
      whiteSpace: "normal",
      shapePadding: 0,
      shapeMargin: 0,
      inlineSize: 0,
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "rgb(0,0,0)",
      solidOpacity: 1,
      vectorEffect: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers",
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto",
      enableBackground: "accumulate",
      stopColor: "rgb(0,0,0)",
      stopOpacity: 1,
      opacity: 1
    },
    fill: "#ffffff",
    "data-original": "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.611 41.963c-2.552.165-5.122.57-7.68 1.23a3.35 3.35 0 0 0-2.404 4.082 3.35 3.35 0 0 0 4.082 2.405c17.176-4.44 34.846 4.867 40.207 20.97 5.362 16.103-3.318 33.339-19.98 39.287-16.662 5.95-35.182-1.748-42.082-17.316a3.35 3.35 0 0 0-4.422-1.705 3.35 3.35 0 0 0-1.705 4.42c8.363 18.868 30.595 28.005 50.463 20.912 19.867-7.093 30.591-28.168 24.084-47.713-5.694-17.101-22.696-27.726-40.563-26.572z",
    style: {
      color: "rgb(0,0,0)",
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: "normal",
      fontFamily: "sans-serif",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontVariantEastAsian: "normal",
      fontFeatureSettings: "normal",
      fontVariationSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecoration: "none",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "rgb(0,0,0)",
      letterSpacing: "normal",
      wordSpacing: "normal",
      textTransform: "none",
      writingMode: "lr-tb",
      direction: "ltr",
      textOrientation: "mixed",
      dominantBaseline: "auto",
      baselineShift: "baseline",
      textAnchor: "start",
      whiteSpace: "normal",
      shapePadding: 0,
      shapeMargin: 0,
      inlineSize: 0,
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "rgb(0,0,0)",
      solidOpacity: 1,
      vectorEffect: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers",
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto",
      enableBackground: "accumulate",
      stopColor: "rgb(0,0,0)",
      stopOpacity: 1,
      opacity: 1
    },
    fill: "#ffffff",
    "data-original": "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.555 217.717c-3.138.02-6.201.166-9.188.431-23.89 2.125-42.838 11.903-55.605 26.25a80.942 80.942 0 0 0-16.813 29.592l-16.273-.064c-6.588-.03-11.951 5.29-11.975 11.877-.026 6.585 5.292 11.945 11.877 11.968l12.402.05c-.12 3.999.014 8.027.397 12.058l-12.897-.057c-6.582-.03-11.943 5.28-11.974 11.862-.03 6.584 5.286 11.947 11.871 11.974l18.201.082c5.853 16.863 16.252 32.377 31.203 42.465 21.127 14.255 50.93 17.766 84.758 4.287 6.12-2.435 9.104-9.372 6.664-15.49-2.438-6.113-9.368-9.094-15.482-6.658-28.33 11.287-48.248 7.782-62.604-1.905-8.394-5.663-15.007-13.425-19.515-22.587l46.974.21c6.585.03 11.947-5.286 11.975-11.87.026-6.583-5.29-11.94-11.871-11.967l-53.598-.239a76.132 76.132 0 0 1-.086-12.072l62.268.246c6.585.03 11.945-5.286 11.972-11.87.027-6.586-5.292-11.944-11.877-11.968l-56.554-.226c2.281-5.126 5.2-9.835 8.77-13.846 11.681-13.128 30.227-21.599 60.378-17.895 6.537.805 12.487-3.845 13.287-10.382.8-6.535-3.848-12.481-10.383-13.282-5.635-.692-11.072-1.008-16.302-.974z",
    style: {
      color: "rgb(0,0,0)",
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: "normal",
      fontFamily: "sans-serif",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontVariantEastAsian: "normal",
      fontFeatureSettings: "normal",
      fontVariationSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecoration: "none",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "rgb(0,0,0)",
      letterSpacing: "normal",
      wordSpacing: "normal",
      textTransform: "none",
      writingMode: "lr-tb",
      direction: "ltr",
      textOrientation: "mixed",
      dominantBaseline: "auto",
      baselineShift: "baseline",
      textAnchor: "start",
      whiteSpace: "normal",
      shapePadding: 0,
      shapeMargin: 0,
      inlineSize: 0,
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "rgb(0,0,0)",
      solidOpacity: 1,
      vectorEffect: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.55821,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto",
      enableBackground: "accumulate",
      stopColor: "rgb(0,0,0)"
    },
    transform: "scale(.26458)",
    fill: "#ffffff",
    "data-original": "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.203 128.242c6.924-.028 13.905-2.697 18.867-7.557 1.487-1.794.203-4.843-2.121-5.029-2.253-.32-3.502 2.052-5.307 2.906-6.656 4.34-15.714 4.485-22.475.29-5.2-3.045-8.85-8.466-9.948-14.366 2.153-.062 4.336.162 6.466-.14 1.731-.678.403-2.337-.538-3.065-2.85-2.83-5.616-5.754-8.524-8.518-1.206-.663-1.924.892-2.746 1.516-2.706 2.705-5.463 5.377-8.135 8.104-.87 1.635 1.208 2.35 2.489 2.079l4.593.01c1.294 9.765 8.229 18.52 17.482 21.936a27.54 27.54 0 0 0 9.897 1.834zM89.691 7.214c-6.923.027-13.904 2.696-18.866 7.557-1.488 1.794-.203 4.842 2.12 5.028 2.254.32 3.503-2.051 5.307-2.906 6.656-4.34 15.715-4.485 22.475-.29 5.2 3.046 8.85 8.466 9.948 14.367-2.153.062-4.336-.163-6.465.14-1.732.678-.403 2.336.537 3.065 2.851 2.829 5.616 5.753 8.524 8.518 1.206.663 1.924-.892 2.746-1.516 2.706-2.706 5.463-5.378 8.135-8.105.87-1.634-1.207-2.35-2.489-2.078l-4.593-.01c-1.294-9.765-8.228-18.521-17.482-21.937a27.54 27.54 0 0 0-9.897-1.833z",
    style: {
      color: "rgb(0,0,0)",
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: "normal",
      fontFamily: "sans-serif",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontVariantEastAsian: "normal",
      fontFeatureSettings: "normal",
      fontVariationSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecoration: "none",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "rgb(0,0,0)",
      letterSpacing: "normal",
      wordSpacing: "normal",
      textTransform: "none",
      writingMode: "lr-tb",
      direction: "ltr",
      textOrientation: "mixed",
      dominantBaseline: "auto",
      baselineShift: "baseline",
      textAnchor: "start",
      whiteSpace: "normal",
      shapePadding: 0,
      shapeMargin: 0,
      inlineSize: 0,
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "rgb(0,0,0)",
      solidOpacity: 1,
      vectorEffect: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.941442,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto",
      enableBackground: "accumulate",
      stopColor: "rgb(0,0,0)"
    },
    fill: "#ffffff",
    "data-original": "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.828 23.273a3.35 3.35 0 0 0-3.35 3.35v1.555c-3.56 1.109-6.58 3.961-7.647 7.585-1.154 3.654-.392 7.985 2.237 10.823 3.95 3.033 7.923 6.038 11.873 9.071 2.457 1.936 2.173 6.157-.526 7.74-2.518 1.725-6.341.331-7.189-2.594-.771-2.128-3.815-2.784-5.397-1.169-1.314 1.165-1.285 3.18-.428 4.605 1.33 2.962 4.015 5.158 7.078 6.11v1.106a3.35 3.35 0 0 0 3.35 3.35 3.35 3.35 0 0 0 3.349-3.35v-1.088c4.687-1.381 8.207-5.998 8.17-10.918.086-3.932-2.053-7.724-5.318-9.869l-10.174-7.763c-1.888-2.48-.418-6.434 2.557-7.217 2.49-.842 5.278.761 6.082 3.203 1.055 2.003 4.16 2.238 5.507.422 1.098-1.276.84-3.15-.027-4.473-1.412-2.673-3.926-4.684-6.797-5.567v-1.562a3.35 3.35 0 0 0-3.35-3.35z",
    style: {
      color: "rgb(0,0,0)",
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: "normal",
      fontFamily: "sans-serif",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontVariantEastAsian: "normal",
      fontFeatureSettings: "normal",
      fontVariationSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecoration: "none",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "rgb(0,0,0)",
      letterSpacing: "normal",
      wordSpacing: "normal",
      textTransform: "none",
      writingMode: "lr-tb",
      direction: "ltr",
      textOrientation: "mixed",
      dominantBaseline: "auto",
      baselineShift: "baseline",
      textAnchor: "start",
      whiteSpace: "normal",
      shapePadding: 0,
      shapeMargin: 0,
      inlineSize: 0,
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "rgb(0,0,0)",
      solidOpacity: 1,
      vectorEffect: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto",
      enableBackground: "accumulate",
      stopColor: "rgb(0,0,0)",
      stopOpacity: 1
    },
    fill: "#ffffff",
    "data-original": "#000000",
    opacity: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrencyWhite);
export default __webpack_public_path__ + "static/media/currencyWhite.0084d4f20733296c7ed6965aafc65581.svg";
export { ForwardRef as ReactComponent };